import { render } from "./PwResolution.vue?vue&type=template&id=38abfbd2"
import script from "./PwResolution.vue?vue&type=script&lang=js"
export * from "./PwResolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__